import React from 'react';

interface Props {
  icon: string;
}

export const Loader: React.FC<Props> = ({ icon }) => (
  <div className="h-fit w-full flex justify-center items-center mt-4 mb-4">
    <img src={icon} alt="Chargement" className="block absolute animate-spin h-6" />
  </div>
);
